import React from 'react'
import Tab from '../UI/Tab'
import { useTranslation } from 'react-i18next'

interface Props {
  tabs: {
    label: string
  }[]
  children: (activeTab: number) => React.ReactNode
}

const Tabs = ({ tabs, children }: Props) => {
  const [activeTab, setActiveTab] = React.useState(0)
  const { t } = useTranslation()
  return (
    <div>
      <div className='flex items-center'>
        {tabs.map((tab, index) => (
          <Tab
            key={tab.label}
            text={t(tab.label)}
            isActive={index === activeTab}
            onClickHandler={() => setActiveTab(index)}
          />
        ))}
      </div>
      {children(activeTab)}
    </div>
  )
}

export default Tabs
